import { compareObjectIds } from 'shared/utils/id/compare';

import { ProtocolAnswer } from './types';

export function findProtocolAnswerByChecklistAnswerId(
  answers: ProtocolAnswer[] | undefined,
  checklistAnswerId: string
): ProtocolAnswer | undefined {
  if (!answers?.length) {
    return undefined;
  }

  return answers.find((answer) =>
    compareObjectIds(
      answer.checklistAnswerId,
      checklistAnswerId,
      'findProtocolAnswerByChecklistAnswerId'
    )
  );
}
